// simple function for datepicker (change format)

export function dateFormatSwitch(value: HTMLFormElement) {
    let finalDateParts = value.split("-");
    finalDateParts = `${finalDateParts[2]}.${finalDateParts[1]}.${finalDateParts[0]}`;

    return finalDateParts;
}
